/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { InvitationType } from './';
import {
    InvitationTypeFromJSON,
    InvitationTypeFromJSONTyped,
    InvitationTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface SignupInitializationRequestForInvitation
 */
export interface SignupInitializationRequestForInvitation {
    /**
     * The ID of the invitation (can be the company-invitation id, the shareable link token or the organization id)
     * @type {string}
     * @memberof SignupInitializationRequestForInvitation
     */
    invitationCode: string;
    /**
     * 
     * @type {InvitationType}
     * @memberof SignupInitializationRequestForInvitation
     */
    invitationType: InvitationType;
    /**
     * The page making this request, so that we can redirect the user back to it in case of a sign-in.
     * @type {string}
     * @memberof SignupInitializationRequestForInvitation
     */
    invitationPageUrl: string;
}

/**
 * Check if a given object implements the SignupInitializationRequestForInvitation interface.
 */
export function instanceOfSignupInitializationRequestForInvitation(value: object): value is SignupInitializationRequestForInvitation {
    if (!('invitationCode' in value) || value['invitationCode'] === undefined) return false;
    if (!('invitationType' in value) || value['invitationType'] === undefined) return false;
    if (!('invitationPageUrl' in value) || value['invitationPageUrl'] === undefined) return false;
    return true;
}

export function SignupInitializationRequestForInvitationFromJSON(json: any): SignupInitializationRequestForInvitation {
    return SignupInitializationRequestForInvitationFromJSONTyped(json, false);
}

export function SignupInitializationRequestForInvitationFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignupInitializationRequestForInvitation {
    if (json == null) {
        return json;
    }
    return {
        
        'invitationCode': json['invitationCode'],
        'invitationType': InvitationTypeFromJSON(json['invitationType']),
        'invitationPageUrl': json['invitationPageUrl'],
    };
}

export function SignupInitializationRequestForInvitationToJSON(value?: SignupInitializationRequestForInvitation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'invitationCode': value['invitationCode'],
        'invitationType': InvitationTypeToJSON(value['invitationType']),
        'invitationPageUrl': value['invitationPageUrl'],
    };
}

